module.exports = __webpack_public_path__ + "img/leftside-banner-new.9ae5770.jpg";